
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { Lead, Category, Operation } from '@/types';

@Component
export default class LeadCategories extends Vue {
  @Prop(Object) readonly lead: undefined | Lead;
  @Prop(Object) readonly operation: undefined | Operation;
  @Prop({ type: Boolean, default: false }) readonly small!: boolean;

  get categories(): null | Category[] {
    return this.$store.getters.categories;
  }

  get hasCategories(): boolean {
    if (this.lead !== undefined) {
      return typeof this.lead.flatCategories === 'string' && this.lead.flatCategories.length > 2;
    }

    if (this.operation !== undefined) {
      return typeof this.operation.categories === 'string' && this.operation.categories.length > 2;
    }

    return false;
  }

  get leadCategories(): number[] {
    if (this.lead !== undefined) {
      return this.hasCategories && 'flatCategories' in this.lead && this.lead.flatCategories
        ? this.lead.flatCategories.substring(1, this.lead.flatCategories.length - 1).split(':')
          .map((s: string) => Number(s))
        : [];
    }

    if (this.operation !== undefined) {
      return this.hasCategories && 'categories' in this.operation && this.operation.categories
        ? this.operation.categories.substring(1, this.operation.categories.length - 1).split(':')
          .map((s: string) => Number(s))
        : [];
    }

    return [];
  }

  leadCategory(categoryId: number) {
    if (!this.categories) return null;

    return this.categories.find((category) => category.id === categoryId);
  }

  categoryColor(categoryId: number): string {
    const category = this.leadCategory(categoryId);

    if (category?.color) return category?.color;

    return category?.hidden || category?.isActive === false ? 'grey' : 'blue-grey';
  }
}
